export default "__VITE_ASSET__B78_yvrN__"